import DbFields from "../../pages/Edit/interfaces/DbFields";

export interface Change {
    id: string;
    datum: string;
    status: status | string;
    feld: DbFields | string;
    wertOriginal: string | boolean;
    wertAenderung: string | boolean;
    suchname?: string;
    name?: string;
}

export enum status {
    ACCEPTED = "Accepted",
    PENDING = "Pending",
    REJECTED = "Rejected"
}